export const baseURL = "https://api.manabakh.ir/api";

// Build version for forced update comparison
// This is compared against minVersion from the backend config
export const BUILD_VERSION = 150;

const config = {
  persistJWT: "secret",
  buildVersion: BUILD_VERSION,
  API: {
    HOME: {},
    REFRESH_TOKEN:
      "https://auth-api.manabakh.ir/v1/auth/api/admin/refresh-token",
    AUTH: {
      LOGIN: `${baseURL}/auth/login`,
      REGISTER: `${baseURL}/auth/register`,
      OTP: `${baseURL}/auth/otp`,
      VERIFY: `${baseURL}/auth/verify`,
      LOGOUT: `${baseURL}/auth/logout`,
    },
    PROFILE: {},
    MOVIE: {},
    CATEGORIES: {},

  },
};

export default config;

